import React from 'react';
import { View, Platform, Text, TouchableOpacity } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { useNavigation } from '@react-navigation/native';
import type { StackNavigationProp } from '@react-navigation/stack';
import AnalyticsDashboard from '../components/AnalyticsDashboard';
import AdBanner from '../components/AdBanner';
import { useInterstitialAd } from '../hooks/useInterstitialAd';
import WebPage from '../components/web/WebPage';
import { createThemedStyles } from '../theme/useThemedStyles';
import { useTheme } from '../context/ThemeContext';
import { useSubscription } from '../context/SubscriptionContext';
import { isWeb } from '../utils/platformUtils';

export type ReportStackParamList = {
  ReportMain: undefined;
  Analytics: undefined;
  Subscription: undefined;
};

const ReportScreen = () => {
  const navigation = useNavigation<StackNavigationProp<ReportStackParamList>>();
  const { colors } = useTheme();
  const styles = useReportStyles();
  const { canShowDashboardCard } = useSubscription();
  useInterstitialAd();

  const showAnalyticsLink = canShowDashboardCard('monthlyContribution');

  const analyticsHeaderAction = showAnalyticsLink ? (
    <TouchableOpacity
      style={styles.headerActionButton}
      onPress={() => navigation.navigate('Analytics')}
      accessibilityRole="link"
      accessibilityLabel="View Detailed Analytics"
    >
      <Text style={[styles.headerActionText, { color: colors.primary.main }]}>
        View Detailed Analytics
      </Text>
      <Ionicons name="arrow-forward" size={16} color={colors.primary.main} />
    </TouchableOpacity>
  ) : undefined;

  const content = (
    <View style={[styles.container, isWeb && styles.containerWeb]}>
      <AnalyticsDashboard onViewDetails={() => navigation.navigate('Analytics')} />
      <AdBanner />
    </View>
  );

  if (Platform.OS === 'web') {
    return (
      <WebPage title="Report" headerAction={analyticsHeaderAction}>
        {content}
      </WebPage>
    );
  }

  return content;
};

const useReportStyles = createThemedStyles((colors) => ({
  container: {
    flex: 1,
    backgroundColor: colors.background.default,
  },
  containerWeb: {
    backgroundColor: colors.background.default,
  },
  headerActionButton: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerActionText: {
    fontSize: 14,
    fontWeight: '600',
    marginRight: 6,
  },
}));

export default ReportScreen;
